import { z } from 'zod';
import { OperationIdSchema } from '../../ids';
import { ItemIdSchema } from '../../models/items';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** A world event's id (WORLD-EVENT). */
const WorldEventIdSchema = z.string().min(1).max(64);

/** One of a passing merchant's goods (IE-10, WD-8): its price a unit and how many are left. */
export const MerchantOfferSchema = z.object({
  item: ItemIdSchema,
  price: z.number().int().positive(),
  left: z.number().int().nonnegative(),
});
export type MerchantOffer = z.infer<typeof MerchantOfferSchema>;

/** What a passing merchant sells while it stays (IE-10): only while its event is open. */
export const getMerchantOffers = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/world-events/:event/offers`,
  access: 'session',
  params: z.object({ event: WorldEventIdSchema }),
  response: z.object({ offers: z.array(MerchantOfferSchema) }),
});

/**
 * Buys from a passing merchant, standing by it (IE-10, WD-8): its price from the treasury to
 * `sink:merchant`, the goods into the backpack. Idempotent; refused beyond what it has left.
 */
export const buyFromMerchant = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/world-events/:event/buy`,
  access: 'session',
  params: z.object({ event: WorldEventIdSchema }),
  body: z.object({
    operationId: OperationIdSchema,
    item: ItemIdSchema,
    count: z.number().int().min(1).max(100),
  }),
  response: z.object({ offers: z.array(MerchantOfferSchema) }),
});
